import { useNavigate } from "react-router-dom";
import MobileBottomNav from "../../components/feature/MobileBottomNav";

export default function DepositPage() {
  const navigate = useNavigate();

  const options = [
    {
      id: "fiat",
      title: "Naira Deposit",
      subtitle: "Fund with NGN via card, bank transfer or USSD",
      icon: "ri-bank-card-line",
      badge: "Instant",
      badgeColor: "#059669",
      badgeBg: "#ECFDF5",
      accentColor: "#059669",
      accentBg: "#ECFDF5",
      features: [
        { icon: "ri-bank-line", text: "Bank transfer, card or USSD" },
        { icon: "ri-time-line", text: "Credited within seconds" },
        { icon: "ri-percent-line", text: "5% processing fee applies" },
      ],
      path: "/deposit-fiat",
    },
    {
      id: "crypto",
      title: "Crypto Deposit",
      subtitle: "Send crypto directly to your wallet address",
      icon: "ri-bit-coin-line",
      badge: "On-chain",
      badgeColor: "#7C3AED",
      badgeBg: "#F5F3FF",
      accentColor: "#7C3AED",
      accentBg: "#F5F3FF",
      features: [
        { icon: "ri-shield-check-line", text: "BTC, ETH, USDT, BNB & more" },
        { icon: "ri-qr-code-line", text: "Scan QR or copy address" },
        { icon: "ri-arrow-right-circle-line", text: "Confirmed after network blocks" },
      ],
      path: "/deposit-crypto",
    },
  ];

  return (
    <div className="min-h-screen bg-[#F7F8FA] pb-28" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
      {/* Header */}
      <div className="bg-white px-5 pt-12 pb-5 border-b border-slate-100">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center"
          >
            <i className="ri-arrow-left-line text-slate-600 text-lg" />
          </button>
          <div>
            <h1 className="text-slate-800 font-bold text-xl">Deposit</h1>
            <p className="text-slate-400 text-xs mt-0.5">Choose how you want to fund your account</p>
          </div>
        </div>
      </div>

      <div className="px-5 pt-6 space-y-4">
        {/* Hero hint */}
        <div className="bg-white border border-slate-100 rounded-2xl px-4 py-3.5 flex items-center gap-3 shadow-sm">
          <div className="w-9 h-9 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <i className="ri-information-line text-emerald-600 text-lg" />
          </div>
          <p className="text-slate-500 text-xs leading-relaxed">
            Naira deposits are instant and great for buying crypto.
            Crypto deposits are on-chain and may take a few minutes.
          </p>
        </div>

        {/* Option cards */}
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => navigate(option.path)}
            className="w-full bg-white border border-slate-100 rounded-3xl p-5 text-left shadow-sm hover:shadow-md hover:border-slate-200 active:scale-[0.99] transition-all"
          >
            {/* Top row */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
                  style={{ background: option.accentBg }}
                >
                  <i className={`${option.icon} text-2xl`} style={{ color: option.accentColor }} />
                </div>
                <div>
                  <p className="text-slate-800 font-bold text-base">{option.title}</p>
                  <p className="text-slate-400 text-xs mt-0.5 leading-snug max-w-[180px]">
                    {option.subtitle}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span
                  className="text-[10px] font-bold px-2.5 py-1 rounded-full"
                  style={{ color: option.badgeColor, background: option.badgeBg }}
                >
                  {option.badge}
                </span>
                <div
                  className="w-8 h-8 rounded-xl flex items-center justify-center"
                  style={{ background: option.accentBg }}
                >
                  <i className="ri-arrow-right-line text-sm" style={{ color: option.accentColor }} />
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="h-px bg-slate-50 mb-4" />

            {/* Feature list */}
            <div className="space-y-2.5">
              {option.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div
                    className="w-6 h-6 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ background: option.accentBg }}
                  >
                    <i className={`${f.icon} text-xs`} style={{ color: option.accentColor }} />
                  </div>
                  <span className="text-slate-500 text-xs">{f.text}</span>
                </div>
              ))}
            </div>
          </button>
        ))}

        {/* Security note */}
        <div className="text-center pt-2 pb-4">
          <p className="text-slate-400 text-xs flex items-center justify-center gap-1.5">
            <i className="ri-lock-2-line text-slate-300" />
            All deposits are secured with 256-bit encryption
          </p>
        </div>
      </div>

      <MobileBottomNav />
    </div>
  );
}
